import React, { useState } from "react";
import {
  IconBold,
  IconItalic,
  IconUnderline,
  IconListNumbers,
  IconList,
  IconCircle,
} from "@tabler/icons-react";

function TextEditor({ value, onChange }) {
  const [formats, setFormats] = useState({
    bold: false,
    italic: false,
    underline: false,
  });

  const toggleFormat = (type) => {
    setFormats((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  const getTextStyle = () => {
    return {
      fontWeight: formats.bold ? "bold" : "normal",
      fontStyle: formats.italic ? "italic" : "normal",
      textDecoration: formats.underline ? "underline" : "none",
    };
  };

  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center justify-start gap-4 px-2 py-4 border-b border-gray-300">
        <button onClick={() => toggleFormat("bold")}>
          <IconBold className={formats.bold ? "text-yellow-500" : ""} />
        </button>
        <button onClick={() => toggleFormat("italic")}>
          <IconItalic className={formats.italic ? "text-yellow-500" : ""} />
        </button>
        <button onClick={() => toggleFormat("underline")}>
          <IconUnderline
            className={formats.underline ? "text-yellow-500" : ""}
          />
        </button>
        <IconListNumbers />
        <IconList />
        <IconCircle />
        <IconCircle />
      </div>

      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={getTextStyle()}
        className="w-full h-40 p-2 mt-2 border border-gray-300 rounded-md resize-none"
        placeholder="Type here..."
      />
    </div>
  );
}

export default TextEditor;
